import React, { Fragment, useState } from 'react';
import { Card, Table, Tabs } from 'antd';
import InventoryHistory from './InventoryHistory';
import { formatCurrency } from '../../../../utils';

const { TabPane } = Tabs;

export default ({ product }) => {

	const [currentTab, setCurrentTab] = useState('1');

	const columns = [
		{
			title: 'STT',
			dataIndex: 'index',
			width: 60,
			align: 'center',
			render: (text, record, index) => index + 1
		},
		{
			title: 'Chi nhánh',
			dataIndex: 'branchName',
			width: 200,
			align: 'center'
		},
		{
			title: 'Tồn kho',
			dataIndex: 'inventory',
			width: 100,
			align: 'center',
			render: (value) => formatCurrency(value)
		},
		{
			title: 'Giá nhập',
			dataIndex: 'costPrice',
			width: 100,
			align: 'center',
			render: (value) => formatCurrency(value)
		},
		{
			title: 'Có thể bán',
			dataIndex: 'availableForSale',
			width: 100,
			align: 'center',
			render: (value) => formatCurrency(value)
		},
		{
			title: 'Đang giao dịch',
			dataIndex: 'inTransaction',
			width: 150,
			align: 'center',
			render: (value) => value ? formatCurrency(value) : 0
		},
		// {
		// 	title: 'Hàng đang về',
		// 	dataIndex: 'itemArriving',
		// 	width: 150,
		// 	align: 'center',
		// 	render: (value) => formatCurrency(value)
		// },
		// {
		// 	title: 'Hàng đang giao',
		// 	dataIndex: 'itemsBeingDelivered',
		// 	width: 150,
		// 	align: 'center',
		// 	render: (value) => formatCurrency(value)
		// },
		// {
		// 	title: 'Tồn tối thiểu',
		// 	dataIndex: 'minimumInventory',
		// 	width: 150,
		// 	align: 'center',
		// 	render: (value) => formatCurrency(value)
		// },
		// {
		// 	title: 'Tồn tối đa',
		// 	dataIndex: 'maximumInventory',
		// 	width: 150,
		// 	align: 'center',
		// 	render: (value) => formatCurrency(value)
		// },
		// {
		// 	title: 'Điểm lưu kho',
		// 	dataIndex: 'inventoryReorderPoint',
		// 	width: 200,
		// 	align: 'center'
		// }
	];
	return <Fragment>
		<Card className={'mt-20'}>
			<Tabs defaultActiveKey={currentTab} onChange={t => setCurrentTab(t)}>
				<TabPane tab="Tồn kho" key="1">
					<Table style={{ marginTop: '3px' }} columns={columns}
								 dataSource={[product?.inventoryDetailResponse || {}]}
								 pagination={false}
								 rowKey={record => record.id}
					/>
				</TabPane>
				<TabPane tab="Lịch sử kho" key="2">
					<InventoryHistory />
				</TabPane>
			</Tabs>
		</Card>
	</Fragment>;
}
